import {lazy, Suspense} from 'react';
import {Navigate, RouteObject} from 'react-router-dom';
import {ErrorBoundary} from "@/shared/components/ErrorBoundary";
import {Spin} from 'antd';

// Lazy load views
const LoanApplicationView = lazy(() => import('./views/LoanApplicationView'));
const MyLoanApplicationsView = lazy(() => import('./views/MyLoanApplicationsView'));
const LoanApplicationDetailsView = lazy(() => import('./views/LoanApplicationDetailsView'));
const CompletedLoanApplicationDetailsView = lazy(() => import('./views/CompletedLoanApplicationDetailsView'));
const LoanRequestsView = lazy(() => import('./views/LoanRequestsView'));
const CompletedLoanRequestsView = lazy(() => import('./views/CompletedLoanRequestsView'));
const ReturnedLoanRequestsView = lazy(() => import('./views/ReturnedLoanRequestsView'));
const ReturnedLoanResubmitView = lazy(() => import('./views/ReturnedLoanResubmitView'));
const PendingLoansView = lazy(() => import('../pending-loans/views/PendingLoansView'));
const DeductionsView = lazy(() => import('../pending-loans/views/DeductionsView'));

// Loading fallback component
const LoadingFallback = () => (
    <div className="flex justify-center items-center h-full p-8">
        <Spin size="large" tip="Loading..."/>
    </div>
);

export const loanRoutes: RouteObject[] = [
    {
        path: '/loans/application',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <LoanApplicationView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/my-applications',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <MyLoanApplicationsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/my-applications/:scopeId',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <LoanApplicationDetailsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/requests/loans/pending',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <LoanRequestsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/requests/loans/completed',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <CompletedLoanRequestsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/completed-requests/:scopeId',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <CompletedLoanApplicationDetailsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/returned-requests',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <ReturnedLoanRequestsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/returned-requests/:scopeId/resubmit',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <ReturnedLoanResubmitView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/pending-loans',
        element: <Navigate to="/loans/pending-loans" replace/>,
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/pending-loans',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <PendingLoansView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    },
    {
        path: '/loans/deductions',
        element: (
            <Suspense fallback={<LoadingFallback/>}>
                <DeductionsView/>
            </Suspense>
        ),
        errorElement: <ErrorBoundary/>,
    }
];
